const features = [
  { icon: "ri-quill-pen-line", title: "专业剧情解析", desc: "深度拆解剧情脉络与叙事结构，帮助观众更好地理解作品内核。" },
  { icon: "ri-user-voice-line", title: "权威演员资讯", desc: "汇总演员代表作与演艺经历，呈现完整立体的演员档案。" },
  { icon: "ri-chat-3-line", title: "真实剧评点评", desc: "专业视角结合大众口碑，提供客观中肯的影视评论参考。" },
];

export default function IntroSection() {
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            关于「色即是空」
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
            色即是空是一个专注于影视内容解析与介绍的专业平台，致力于为广大影视爱好者和观众提供全面、深入的电影和电视剧解析、剧情点评及演员资讯服务。我们相信，一部好的作品值得被认真解读，一次好的观影体验离不开专业的内容引导。
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="flex-1 bg-background-100 rounded-lg p-4">
              <p className="text-2xl font-bold text-primary-500">500+</p>
              <p className="text-xs text-foreground-500 mt-1">影视作品收录</p>
            </div>
            <div className="flex-1 bg-background-100 rounded-lg p-4">
              <p className="text-2xl font-bold text-primary-500">300+</p>
              <p className="text-xs text-foreground-500 mt-1">演员资料档案</p>
            </div>
            <div className="flex-1 bg-background-100 rounded-lg p-4">
              <p className="text-2xl font-bold text-primary-500">10w+</p>
              <p className="text-xs text-foreground-500 mt-1">累计用户访问</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4">
          {features.map((f) => (
            <div key={f.title} className="flex items-start gap-4 bg-background-50 border border-background-200 rounded-lg p-5">
              <div className="w-11 h-11 rounded-full bg-secondary-100 flex items-center justify-center shrink-0">
                <i className={`${f.icon} text-xl text-secondary-700`}></i>
              </div>
              <div>
                <h3 className="font-semibold text-foreground-900 mb-1">{f.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}